import React,{ useState} from "react";
import clsx from "clsx";
import  {useHistory} from "react-router"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';

function RedirectFailed({  }) {
    let history = useHistory();
    const handleBack = (e) => {
        e.preventDefault()
        history.push("/")
    };

    return (
        <div className="mt-4">
            <div className="payment-successful-container d-flex justify-content-center">
                <div className="payment-successful-content">
                    <FontAwesomeIcon icon={faCircleXmark} className="fa-3x"/>
                    <br/>
                    <p>Oh No! Payment has issue please try again.</p>
                    <div className="d-flex justify-content-center pt-3">
                        <button className={clsx("btn custom-button-primary")} type="submit" onClick={handleBack}
                                style={{ backgroundColor: "#9D7905" }}>
                            Back
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default RedirectFailed;
